
export type GetStreamingInfoByPath200SupportedDevicesItem = typeof GetStreamingInfoByPath200SupportedDevicesItem[keyof typeof GetStreamingInfoByPath200SupportedDevicesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStreamingInfoByPath200SupportedDevicesItem = {
  browser: 'browser',
  mobile: 'mobile',
  smarttv: 'smarttv',
} as const;
